/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Edit_TitleInputs */

const en_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Issue`)
};

const fr_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l'incident`)
};

const de_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem bearbeiten`)
};

const it_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica problema`)
};

const ru_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать проблему`)
};

const es_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar problema`)
};

const zh_cn2_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑问题`)
};

const ja_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題を編集`)
};

const hi_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या संपादित करें`)
};

const pt_pt2_manual_qc_edit_title = /** @type {(inputs: Manual_Qc_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar problema`)
};

/**
* | output |
* | --- |
* | "Edit Issue" |
*
* @param {Manual_Qc_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_edit_title = /** @type {((inputs?: Manual_Qc_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_edit_title(inputs)
	if (locale === "de") return de_manual_qc_edit_title(inputs)
	if (locale === "it") return it_manual_qc_edit_title(inputs)
	if (locale === "ru") return ru_manual_qc_edit_title(inputs)
	if (locale === "es") return es_manual_qc_edit_title(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_edit_title(inputs)
	if (locale === "ja") return ja_manual_qc_edit_title(inputs)
	if (locale === "hi") return hi_manual_qc_edit_title(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_edit_title(inputs)
	return en_manual_qc_edit_title(inputs)
});